import { Alert } from 'antd'

export function ResumedNotice() {
  return (
    <Alert
      type='info'
      showIcon
      message='Gravi was restarted and is continuing your task.'
      style={{ alignSelf: 'center' }}
    />
  )
}
